export default __webpack_public_path__ + "img/ePwMxLOK.c2208ed6.svg";